import { useSelector } from "react-redux";
import { selectMapScreen } from "../features/mapScreen/mapScreenSlice";
import { AnimatePresence, motion } from "framer-motion";

export function BeRightBackOverlay({
	isFullscreen = false,
}: {
	isFullscreen: boolean;
}) {
	const mapScreen = useSelector(selectMapScreen);

	return (
		<AnimatePresence>
			{isFullscreen && (
				<motion.div
					initial={{ y: -300, opacity: 0 }}
					animate={{ y: 0, opacity: 1 }}
					exit={{ y: -300, opacity: 0 }}
					className="bg-cityhub-green/75 fixed z-40 inset-0 flex justify-center items-center transition-opacity duration-300"
				>
					<div className={`text-center py-4 px-24 text-black`}>
						<div className="flex justify-center items-center">
							<div className="p-8 rounded-md flex flex-col items-center text-8xl">
								CityHost {mapScreen.CityHost?.Name ?? ""}<br />will be right back!
							</div>
						</div>
					</div>
				</motion.div>
			)}
		</AnimatePresence>
	);
}
